import { Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { HubConfigRolesBulkDeleteDrawerComponent } from './hub-config-roles-bulk-delete-drawer.component';

@Injectable()
export class HubConfigRolesBulkDeleteDrawerService {
  constructor(private readonly drawerService: NzDrawerService) {}

  openDrawer() {
    return this.drawerService.create({
      nzBodyStyle: { padding: 0 },
      nzContent: HubConfigRolesBulkDeleteDrawerComponent,
      nzTitle: $localize`:@@hubConfigRolesBulkDeleteDrawer.deleteRoleTitle: Delete roles`,
      nzWidth: '600px',
    }).afterClose;
  }
}
